import { useActiveConversationId } from './useActiveConversationId'
import { useConversation } from './useConversation'

export const useActiveConversationData = () => {
  const { activeConversationId } = useActiveConversationId()

  const { data: activeConversationData, errorStatus, isSuccess, isFetching, isPending }
    = useConversation(activeConversationId)

  return {
    activeConversationData,
    errorStatus,
    isFetching,
    isPending,
    isSuccess,
  }
}
